// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { getLeiValidationMessageString } = require('utilities/leiValidationMessage');
const mifidErrorHelper = require('mifid/utilities/mifidErrorHelper');

// @vendors
const get = require('lodash/object/get');

// @actions
const errorActions = require('actions/brokerError');

// @constants
const actionTypes = require('constants/actionTypes');
const {
    CONNECTION_CHANNEL_INTERNET,
    BROKER_NATIONAL_ID_DOC_TYPE,
    BROKER_CHECK_ALLOWED_CCV_CONTRACT_PARAM,
    BROKER_CHECK_NOT_ALLOWED_CCV_CONTRACT_ERROR,
} = require('constants/index');
const { COUNTRY_CODE_ES } = require('commonsConstants/countryCodes')

function checkClientPersonalInfoSuccess(clientPersonalInfoUpdated) {
    return {
        type: actionTypes.BROKER_CHECK_CLIENT_PERSONAL_INFO_SUCCESS,
        payload: {
            clientPersonalInfoUpdated
        }
    };
}

function checkClientPersonalInfoError(error) {
    const clientPersonalInfoNotUpdated = get(error, 'body.status') == 404;

    if (clientPersonalInfoNotUpdated) {
        const clientPersonalInfoUpdated = false;
        return checkClientPersonalInfoSuccess(clientPersonalInfoUpdated);
    } else {
        return {
            type: actionTypes.BROKER_CHECK_CLIENT_PERSONAL_INFO_ERROR,
            payload: {
                data: error
            }
        };
    }
}

function checkClientPersonalInfoFRequest() {
    return {
        type: actionTypes.BROKER_CHECK_CLIENT_PERSONAL_INFO_REQUEST,
        payload: {}
    }
}

function generateNationalIdDocumentRequest() {
    return {
        type: actionTypes.BROKER_GENERATE_NATIONAL_ID_DOC_REQUEST,
        payload: {}
    }
}

function generateNationalIdDocumentSuccess(response) {
    return {
        type: actionTypes.BROKER_GENERATE_NATIONAL_ID_DOC_SUCCESS,
        payload: {
            data: response
        }
    }
}

function generateNationalIdDocumentError(error) {
    return {
        type: actionTypes.BROKER_GENERATE_NATIONAL_ID_DOC_ERROR,
        payload: {
            data: error
        }
    }
}

function openClientWarningModal() {
    return {
        type: actionTypes.BROKER_SHOW_CLIENT_WARNING_INFO,
        payload: {}
    }
}

function hideClientWarningModal() {
    return {
        type: actionTypes.BROKER_HIDE_CLIENT_WARNING_INFO,
        payload: {}
    }
}

function preventGenerateDocumentError() {
    return {
        type: actionTypes.BROKER_PREVENT_GENERATE_NATIONAL_ID_DOCUMENT_ERROR,
        payload: {}
    }
}

const checkPersonalInformationData = () => (dispatch, getState) => {
    const immClientWarningModal = getState().brokerClientWarningModal;
    const immProfile = getState().profile
    const originCountry = immProfile.get('originCountry').toUpperCase()
    const paisNacionalidad = immProfile.get('paisNacionalidad').toUpperCase()
    if ((originCountry === COUNTRY_CODE_ES) || (paisNacionalidad !== COUNTRY_CODE_ES && originCountry !== COUNTRY_CODE_ES)) {
        dispatch(checkClientPersonalInfoSuccess(true))
        return
    }
    const notFetching = !immClientWarningModal.get('isFetching');

    if (notFetching) {

        const URLCheckAllowedCCVContract = apiURLBuilder.getURL('brokerCheckAllowedCCVContract', {
            ordenFinalidad: BROKER_CHECK_ALLOWED_CCV_CONTRACT_PARAM,
        })

        dispatch(checkClientPersonalInfoFRequest());

        return APIGet(dispatch, URLCheckAllowedCCVContract)
            .then(res => {
                // status=200 AND allowed=<Boolean>
                if (!res.allowed) {
                    const errorText = BROKER_CHECK_NOT_ALLOWED_CCV_CONTRACT_ERROR

                    dispatch(checkClientPersonalInfoError({
                        error: {
                            status: 200,
                            description: errorText,
                        },
                        text: errorText,
                    }))
                }
                else {
                    // (status=200 AND allowed=false) === (status > 2XX)
                    dispatch(checkClientPersonalInfoSuccess(true))
                }
            })
            // status > 2XX (3XX, 4XX, etc)
            .catch(err => dispatch(checkClientPersonalInfoError(err)))
    }
};

const generateNationalIdDocument = (history) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immAccessKey = getState().accessKeyChange;

    const lastAccess = immAccessKey.getIn(['cmcContract', 'lastAccess']);
    const nombreCliente = immProfile.get('nombreCliente');

    const mifidErrorDatePassed = mifidErrorHelper.nationalIdDateValidation(lastAccess)

    const data = {
        "channel": CONNECTION_CHANNEL_INTERNET,
        "clientAlias": nombreCliente,
        "documentType": BROKER_NATIONAL_ID_DOC_TYPE,
        "mifidWarningText": getLeiValidationMessageString(lastAccess)
    };

    const requestData = {
        query: data
    };

    dispatch(generateNationalIdDocumentRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('generateNationalIdDocument'), requestData).then(
        (response) => dispatch(generateNationalIdDocumentSuccess(response)),
        (error) => {
            dispatch(generateNationalIdDocumentError(error));
            const showError = !(getState().brokerClientWarningModal.get('preventError'));
            const notOpen = !(getState().brokerClientWarningModal.get('isOpen'));
            if (showError && notOpen && mifidErrorDatePassed) {        // If API failed with delay then display error on Continue flow only
                const errorKey = get(error, ["body", "error"], "");
                dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history))
            }

        }
    );
};

const showClientWarningModal = (history) => dispatch => {
    dispatch(openClientWarningModal());
    dispatch(generateNationalIdDocument(history));
};

module.exports = {
    checkPersonalInformationData,
    showClientWarningModal,
    hideClientWarningModal,
    preventGenerateDocumentError
}
